import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

import * as incpectionAction from "../../../../redux/actions/incpectionAction";
import * as swInspectionAction from "../../../../redux/storm-water/actions/swInspectionAction";
import * as stateCityAction from "../../../../redux/actions/stateCityAction";
import * as swCommonAction from "../../../../redux/storm-water/actions/swCommonAction";

import SuccessScreen from "../../../../library/custom/success/successScreen";
import Loader from "../../../../library/common/Loader";
import SetInspection from "../components/setInspection";

import {
  ACCESS_DENIED,
  INSPECTION_FORM_LIST,
} from "../../../../constant/routeContant";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { sortAlphabetically } from "../../../../utils/helper";

const SetInspectionContainer = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const questsetId = location?.state?.row;
  const editMode = location?.state?.editMode;

  const [successScreens, setSuccessScreens] = useState(false);
  const [clearCategory, setClearCategory] = useState(false);
  const [clearStatus, setClearStatus] = useState(false);
  const [clearSubCategory, setClearSubCategory] = useState(false);
  const [clearQuestion, setClearQuestion] = useState(false);

  const defaultCatData = { search: "", page: 1, pageSize: 1000 };
  const defaultSubCatData = { search: "", page: 1, pageSize: 1000 };
  const refData = { flags: 3 };
  const defaultSubData = { type: 9 };

  // Redux selectors
  const {
    createSwQuestionSet,
    updateSwQuestionSet,
    createSwCategory,
    createSwSubCategory,
    createSwQuestion,
  } = useSelector((state) => ({
    createSwQuestionSet: state.createSwQuestionSet,
    updateSwQuestionSet: state.updateSwQuestionSet,
    createSwCategory: state.createSwCategory,
    createSwSubCategory: state.createSwSubCategory,
    createSwQuestion: state.createSwQuestion,
  }));

  const getInspectionAcknowledgement = useSelector(
    (state) => state.getInspectionAcknowledgement,
  );
  const getSwReference = useSelector((state) => state.getSwReference);
  const stateData = useSelector((state) => state.state);
  const getCategoriesList = useSelector((state) => state.getSwCategoryList);
  const getSubCategoriesList = useSelector(
    (state) => state.getSwSubCategoryList,
  );

  // Loader logic
  const showLoader = useSelector((state) =>
    [
      state.createSwQuestionSet,
      state.updateSwQuestionSet,
      state.getSwCategoryList,
      state.getSwSubCategoryList,
      state.getQuestionsList,
      state.createSwCategory,
      state.createSwSubCategory,
      state.createSwQuestion,
      state.state,
      state.getSwReference,
      state.getInspectionAcknowledgement,
    ].some((slice) => slice?.isLoading),
  );

  // Dispatchers
  const getInspectionAcknowledgementData = () =>
    dispatch(incpectionAction.getInspectionAcknowledgement(defaultSubData));
  const getSwReferenceData = () =>
    dispatch(swCommonAction.getSwReference(refData));
  const getStateData = () => dispatch(stateCityAction.getState());
  const getCategoriesListData = () =>
    dispatch(swInspectionAction.getSwCategoryList(defaultCatData));
  const getSubCategoriesListData = () =>
    dispatch(swInspectionAction.getSwSubCategoryList(defaultSubCatData));

  // Submit handlers
  const onSubmit = (data) => {
    setSuccessScreens(true);
    setClearStatus(true);
    dispatch(swInspectionAction.createSwQuestionSet(data));
  };

  const onSetSubmit = (data) => {
    setSuccessScreens(true);
    dispatch(swInspectionAction.updateSwQuestionSet(data));
  };

  const onCategorySubmit = (data) => {
    setClearCategory(true);
    dispatch(swInspectionAction.createSwCategory(data));
  };

  const onSubCategorySubmit = (data) => {
    setClearSubCategory(true);
    dispatch(swInspectionAction.createSwSubCategory(data));
  };

  const onQuestionSubmit = (data) => {
    setClearQuestion(true);
    dispatch(swInspectionAction.createSwQuestion(data));
  };

  // Effects
  useEffect(() => {
    dispatch(incpectionAction.clearCloneQuestionSet());
    dispatch(swInspectionAction.clearSwQuestionSet());
    getCategoriesListData();
    getSubCategoriesListData();
    getSwReferenceData();
    getInspectionAcknowledgementData();
    getStateData();
  }, []);

  useEffect(() => {
    if (
      createSwCategory?.status === "SUCCESS" &&
      !createSwCategory?.isLoading &&
      clearCategory
    ) {
      getCategoriesListData();
      toast("Category Added successfully");
    }
  }, [createSwCategory]);

  useEffect(() => {
    if (
      createSwSubCategory?.status === "SUCCESS" &&
      !createSwSubCategory?.isLoading &&
      clearSubCategory
    ) {
      getSubCategoriesListData();
      toast("Sub Category Added successfully");
    }
  }, [createSwSubCategory]);

  useEffect(() => {
    if (
      createSwQuestionSet?.status === "SUCCESS" &&
      !createSwQuestionSet?.isLoading &&
      clearStatus
    ) {
      toast("Inspection Name Added successfully");
    }
  }, [createSwQuestionSet]);

  useEffect(() => {
    if (
      createSwQuestion?.status === "SUCCESS" &&
      !createSwQuestion?.isLoading &&
      clearQuestion
    ) {
      const responseCode =
        createSwQuestion?.data?.responseMessages?.responseCode;
      const responseMessage =
        createSwQuestion?.data?.responseMessages?.responseMessage;

      if (responseCode === "HBNG001") toast("Questions Added successfully");
      if (responseCode === "HBNG002") toast(responseMessage);
    }
  }, [createSwQuestion]);

  // Safe fallback for inspectionAcknowledgement
  const sortedInspectionAcknowledgement = sortAlphabetically(
    getInspectionAcknowledgement?.data?.result?.filter((x) => x.status) || [],
  );

  const successScreen = (id, successMsg, label1, label4, label2) => (
    <SuccessScreen
      id={id}
      isUpdate={successMsg}
      route={INSPECTION_FORM_LIST}
      label1={label1}
      label4={label4}
      label2={label2}
    />
  );

  if (!checkPrivileges([12, 93, 94])) {
    navigate(ACCESS_DENIED);
    return null;
  }

  return (
    <>
      {showLoader && <Loader />}
      {successScreens &&
      createSwQuestionSet?.status === "SUCCESS" &&
      createSwQuestionSet?.data ? (
        successScreen(
          createSwQuestionSet.data.questionSetId,
          "Inspection Form Created Successfully",
          "Set Id",
          "Inspection Form List in",
          " ",
        )
      ) : successScreens &&
        updateSwQuestionSet?.status === "SUCCESS" &&
        updateSwQuestionSet?.data ? (
        successScreen(
          updateSwQuestionSet.data.questionSetId,
          "Inspection Form Updated Successfully",
          " ",
          "Inspection Form List in",
          "has been Updated",
        )
      ) : (
        <>
          <SetInspection
            stateData={stateData?.data?.getState || []}
            getCategoriesList={
              getCategoriesList?.data?.result?.categoryList?.filter(
                (x) => x.status,
              ) || []
            }
            getSubCategoriesList={
              getSubCategoriesList?.data?.result?.categoryList?.filter(
                (x) => x.status,
              ) || []
            }
            getSubCategoriesListData={getSubCategoriesListData}
            onSubmit={onSubmit}
            onSetSubmit={onSetSubmit}
            createSwQuestionSet={createSwQuestionSet}
            editMode={editMode}
            questsetId={questsetId}
            onCategorySubmit={onCategorySubmit}
            onSubCategorySubmit={onSubCategorySubmit}
            onQuestionSubmit={onQuestionSubmit}
            createSwQuestion={createSwQuestion}
            getSwReference={getSwReference?.data?.insTypeMstList || []}
            inspectionAcknowledgement={sortedInspectionAcknowledgement}
          />
          <ToastContainer />
        </>
      )}
    </>
  );
};

export default SetInspectionContainer;
